import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "loading-spinner"
}
const _hoisted_2 = {
  key: 2,
  class: "no-data"
}

import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useSelectionStore } from '@/pinia/selection'
import { storeToRefs } from 'pinia'
import { OVERVIEW_DATA } from '@/design-system/molecules/AccordionTable.vue'
import { SummaryObject, SummaryType } from '@/interfaces/summary.interface'
import AccordionCardInfoDisplay from '@/components/features/info-display/AccordionCardInfoDisplay.vue'
import AccordionTable from '@/design-system/molecules/AccordionTable.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoDisplayZoneSummaryCard',
  props: {
    isLoading: { type: Boolean },
    showForEntityTypes: {},
    title: {},
    zoneSummaryData: {}
  },
  setup(__props: any) {

const props = __props

const selectionStore = useSelectionStore()

const { t } = useI18n()
const { clickedEntityType } = storeToRefs(selectionStore)

const isExpanded = ref(false)
const zonesList = ref<any[]>([])

function generateZonesList(zoneData: SummaryObject[]) {
  let zonesArray: any[] = []
  if (!zoneData?.length) {
    zonesList.value = zonesArray
    return
  }
  zonesArray = props.zoneSummaryData.map((object: SummaryObject) => {
    const types = object.types.map((item: SummaryType) => {
      return {
        color: item.color,
        value1: item.typeName,
        value2: item.count,
        value3: item.area
      }
    })
    const mappedObject: OVERVIEW_DATA = {
      id: object.id ?? object.categoryId,
      value1: object.categoryName,
      value2: object.count,
      value3: object.area as number,
      items: types,
      visible: true
    }
    return mappedObject
  })
  zonesList.value = zonesArray
}
function toggleCategory(id: string) {
  zonesList.value.map((item: any) => {
    if (item.id === id) {
      item.visible = !item.visible
    }
    return item
  })
}
function handleClick() {
  isExpanded.value = !isExpanded.value
}

watch(
  () => props.zoneSummaryData,
  (newData) => {
    generateZonesList(newData)
  }
)

return (_ctx: any,_cache: any) => {
  return (_ctx.showForEntityTypes.includes(_unref(clickedEntityType)))
    ? (_openBlock(), _createBlock(AccordionCardInfoDisplay, {
        key: 0,
        heading: _ctx.title,
        isExpanded: isExpanded.value,
        onOnClicked: handleClick
      }, {
        content: _withCtx(() => [
          (!_ctx.isLoading && zonesList.value.length)
            ? (_openBlock(), _createBlock(AccordionTable, {
                key: 0,
                class: "zone-summary",
                titles: {
          title1: _unref(t)('general__text__category'),
          title2: _unref(t)('general__data__quantity'),
          title3: `${_unref(t)('general__data__area')}`
        },
                data: zonesList.value,
                firstColumnWide: true,
                clickable: true,
                onToggleCategory: toggleCategory
              }, null, 8, ["titles", "data"]))
            : (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(PulseLoader, {
                    loading: true,
                    color: "#3F46D6"
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('general__data__no-data-published')), 1)
                ]))
        ]),
        _: 1
      }, 8, ["heading", "isExpanded"]))
    : _createCommentVNode("", true)
}
}

})